<template lang="html">

<div class="upload-img">
      <el-upload
        class="upload-demo"
        ref="upload"
        accept="image/*"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        :file-list="fileList"
        :limit="20"
        :on-exceed="handleExeccd"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove">
        <el-button size="small" type="primary">
             <span>点击上传</span>
        </el-button>
      </el-upload>
</div>

</template>

<script>
import { getToken } from '@/utils/auth';
import { getFileToken,getViewKey,detFile } from '@/api/account';
export default {
    name:'imgsUpload',
    props:['files','listType','limit','tips'],
    data(){
        return{
            fileList: [],
            postDat:'',

            viewDat:'',
            fileMap:{},
            fileStore:[]
        }
    },
    watch:{
        files:function(e){

            this.filesSet(e);
        }
    },
    methods:{
        filesSet:function(e){
            if(this.fileList.length === 0 && e && this.viewDat){
               var files = JSON.parse(e);
               files.forEach(item => {
                   item.url = this.viewDat.imagePreUrl + '/id/' + item.id + '/token/' + this.viewDat.token;
               })
               this.fileList = files;
               this.fileStore = files;
            }
        },
        handleExeccd:function(){
            this.$message.error('上传文件已达上限！');
        },
        beforeUpload:function(file){
            var isImage = file.type.split('\/')[0] === 'image';

            var isLt100M = file.size / 1024 / 1024 <= 2;
            if (!isLt100M) {
                this.$message.error('文件大小不能超过 2 MB!');
            }

            if(!isImage){
                this.$message.error('只能上传格式为 jpg/jpeg/png/pdf/gif 的文件');
            }

            if(isLt100M && isImage){
               return true;
            }
        },

        handlePictureCardPreview(file) {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        },

        handleSuccess:function(res,file,fileList){
            var newMap = {};
            fileList.forEach(item => {
                if(item.id){
                    newMap[item.uid] = item.id;
                }else if(this.fileMap[item.uid]){
                    newMap[item.uid] = this.fileMap[item.uid];
                }
            });
            newMap[file.uid] = this.postDat.key;
            this.fileMap = newMap;
            this.flieStoreSet(fileList);
        },

        handleRemove:function(file,fileList){
            detFile({id:file.id || this.fileMap[file.uid],fileType:1});
            this.flieStoreSet(fileList);
        },

        flieStoreSet:function(fileList){
            this.fileStore = [];
            fileList.forEach(item => {
                var file = {
                    name:item.name,
                    id:this.fileMap[item.uid],
                }
                this.fileStore.push(file);
            })
            this.$emit('fileChange',this.fileStore);
        }

    },
    mounted:function(){
             let vm = this;
             var userInfo = this.$store.getters.userInfo;

             this.$refs.upload.$refs['upload-inner'].uploadFiles = function(files){
                 let svm = vm.$refs.upload.$refs['upload-inner'];
                 if (svm.limit && svm.fileList.length + files.length > svm.limit) {
                   svm.onExceed && svm.onExceed(files, svm.fileList);
                   return;
                 }
                 let postFiles = Array.prototype.slice.call(files);
                 if (!svm.multiple) { postFiles = postFiles.slice(0, 1); }
                 if (postFiles.length === 0) { return; }


                 getFileToken({userId:userInfo.userId,fileType:1}).then(res => {
                      vm.postDat = res;
                      postFiles.forEach(rawFile => {
                        svm.onStart(rawFile);
                        rawFile.postUrl = vm.postDat.fileUploadUrl;
                        if (svm.autoUpload) svm.upload(rawFile);
                      });
                 });
             };

             this.$refs.upload.$refs['upload-inner'].post = function(rawFile){
                  const { uid } = rawFile;
                  let svm = vm.$refs.upload.$refs['upload-inner'];
                  let s = {
                      token:getToken(),
                      key:vm.postDat.key,
                      fileSize:rawFile.size
                  };
                      const options = {
                        headers: svm.headers,
                        withCredentials: this.withCredentials,
                        file: rawFile,
                        data: s,
                        filename: svm.name,
                        action: rawFile.postUrl,
                        onProgress: e => {
                          svm.onProgress(e, rawFile);
                        },
                        onSuccess: res => {
                          svm.onSuccess(res, rawFile);
                          delete this.reqs[uid];
                        },
                        onError: err => {
                          svm.onError(err, rawFile);
                          delete this.reqs[uid];
                        }
                      };
                      const req = svm.httpRequest(options);
                      svm.reqs[uid] = req;
                      if (req && req.then) {
                        req.then(options.onSuccess, options.onError);
                      }
             };
    },
    created:function(){

        getViewKey().then(res => {
            this.viewDat = {
                imagePreUrl:res.imagePreUrl,
                token:res.token
            };
            this.filesSet(this.files);
        })
    }
}
</script>

<style lang="css" scoped>

.upload-img{
    padding-top: 2px;
}

.el-upload__tip{
    display: inline-block;
    margin-left: 12px;
}

.imgCard{
    width: 120px;
    height: 120px;
    border-radius: 6px;
    border:1px solid #F1F1F1;
    margin-top: 12px;
}

.imgCard .pgress{
   margin: 15px;
}

</style>



// WEBPACK FOOTER //
// imgsUpload.vue?33941fbb